import { Routes } from '@angular/router';
import { TppComplete } from './components/tpp/tpp-complete/tpp-complete';
import { TppInstructions } from './components/tpp/tpp-instructions/tpp-instructions';
import { TppClaimants } from './components/tpp/tpp-claimants/tpp-claimants';
import { Home } from './components/home/home';
import { ConsumerClaimants } from './components/consumer/consumer-claimants/consumer-claimants';
import { ConsumerComplete } from './components/consumer/consumer-complete/consumer-complete';
import { ConsumerInstructions } from './components/consumer/consumer-instructions/consumer-instructions';
import { LandingComponent } from './components/landing/landing.component';
import { SuntaroHome } from './components/sun-taro-classes-homepage/sun-taro-classes-homepage';
import { SuntaroCourtDocs } from './components/sun-taro-classes-courtdocuments/sun-taro-classes-courtdocuments';
import { SuntaroNotice } from './components/sun-taro-classes-notice/sun-taro-classes-notice';
import { SuntaroEspanol } from './components/sun-taro-classes-espanol/sun-taro-classes-espanol';
import { SuntaroContact } from './components/sun-taro-classes-contact/sun-taro-classes-contact';
import { Lookup } from './components/lookup/lookup';

import { CertifiedHome } from './components/certified-litigation-classes-homepage/certified-litigation-classes-homepage';
import { CertifiedNotice } from './components/certified-litigation-classes-notice/certified-litigation-classes-notice';
import { CertifiedCourtDocs } from './components/certified-litigation-classes-courtdocuments/certified-litigation-classes-courtdocuments';
import { CertifiedEspanol } from './components/certified-litigation-classes-espanol/certified-litigation-classes-espanol';
import { CertifiedContact } from './components/certified-litigation-classes-contact/certified-litigation-classes-contact';

import { ApotexHome } from './components/apotex-heritage-classes-homepage/apotex-heritage-classes-homepage';
import { ApotexNotice } from './components/apotex-heritage-classes-notice/apotex-heritage-classes-notice';
import { ApotexCourtDocs } from './components/apotex-heritage-classes-courtdocuments/apotex-heritage-classes-courtdocuments';
import { ApotexContact } from './components/apotex-heritage-classes-contact/apotex-heritage-classes-contact';

import { SandozHome } from './components/sandoz-classes-homepage/sandoz-classes-homepage';
import { SandozNotice } from './components/sandoz-classes-notice/sandoz-classes-notice';
import { SandozCourtDocs } from './components/sandoz-classes-courtdocuments/sandoz-classes-courtdocuments';
import { SandozEspanol } from './components/sandoz-classes-espanol/sandoz-classes-espanol';
import { SandozContact } from './components/sandoz-classes-contact/sandoz-classes-contact';

import { RegisterComponent } from './components/register/register';
import { RegisterHomeComponent } from './components/register-home/register-home';
 import { RegisterComplete } from './components/register-complete/register-complete';


export const routes: Routes = [

  { path: '', component: LandingComponent },   // ✅ Home loads first
  { path: 'home', component: Home },
  { path: 'lookup', component: Lookup },

  { path: 'landing', component: LandingComponent },

  { path: 'register', component: RegisterComponent },
  { path: 'register-home', component: RegisterHomeComponent },
   { path: 'register-complete', component: RegisterComplete },


  { path: 'sun-taro-classes-homepage', component: SuntaroHome },
  { path: 'sun-taro-classes-courtdocuments', component: SuntaroCourtDocs },
  { path: 'sun-taro-classes-notice', component: SuntaroNotice },
  { path: 'sun-taro-classes-espanol', component: SuntaroEspanol },
  { path: 'sun-taro-classes-contact', component: SuntaroContact },

  { path: 'certified-litigation-classes-homepage', component: CertifiedHome },
  { path: 'certified-litigation-classes-notice', component: CertifiedNotice },
  { path: 'certified-litigation-classes-courtdocuments', component: CertifiedCourtDocs },
  { path: 'certified-litigation-classes-espanol', component: CertifiedEspanol },
  { path: 'certified-litigation-classes-contact', component: CertifiedContact },

  { path: 'apotex-heritage-classes-homepage', component: ApotexHome },
  { path: 'apotex-heritage-classes-notice', component: ApotexNotice },
  { path: 'apotex-heritage-classes-courtdocuments', component: ApotexCourtDocs },
  { path: 'apotex-heritage-classes-contact', component: ApotexContact },

  { path: 'sandoz-classes-homepage', component: SandozHome },
  { path: 'sandoz-classes-notice', component: SandozNotice },
  { path: 'sandoz-classes-courtdocuments', component: SandozCourtDocs },
  { path: 'sandoz-classes-espanol', component: SandozEspanol },
  { path: 'sandoz-classes-contact', component: SandozContact },




  { path: 'tpp-instructions', component: TppInstructions },
  { path: 'tpp-claimants', component: TppClaimants },
  { path: 'tpp-complete', component: TppComplete },

  { path: 'consumer-instructions', component: ConsumerInstructions },
  { path: 'consumer-claimants', component: ConsumerClaimants },
  { path: 'consumer-complete', component: ConsumerComplete },

  { path: '**', redirectTo: '' }

  //{ path: '', pathMatch: 'full', redirectTo: 'tpp-instructions' },
  //{ path: 'tpp-instructions', component: TppInstructions },
  //{ path: 'tpp-claimants', component: TppClaimants },
  //{ path: 'tpp-complete', component: TppComplete },
  //{ path: 'home', component: Home },
  //{ path: '**', redirectTo: 'tpp-instructions' },

];
